import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { CommentIcon } from '@fiverr-private/visuals';
import { howLongAgo } from '@fiverr-private/futile/lib/datetime';
import { getContext } from '@fiverr-private/fiverr_context';
import { AppI18n } from '../../../../i18n';

interface HighlightsData {
    lastConversationAt?: number;
}

export interface LastConversationProps {
    highlightsData?: HighlightsData;
}

export const LastConversation = ({ highlightsData = {} }: LastConversationProps) => {
    const { lastConversationAt } = highlightsData;

    if (!lastConversationAt) {
        return null;
    }

    const { locale } = getContext();
    const time = howLongAgo(lastConversationAt * 1000, { locale });

    return (
        <Stack gap="2" alignItems="center">
            <CommentIcon />
            <AppI18n k="highlights.last_conversation" params={{ time }} />
        </Stack>
    );
};
